
import { Bot } from "lucide-react";

export const EmptyChat = () => {
  return (
    <div className="flex items-center justify-center h-32 text-center p-4">
      <div>
        <Bot className="h-12 w-12 mx-auto mb-4 text-primary opacity-50" />
        <p className="text-muted-foreground">
          How can I help you with this event?
        </p>
      </div>
    </div>
  );
};
